/**
 * 河川予警報
 */
import Repository from "./MapRepository";

const resource = "";
export default {
  /**
   * 洪水予報GeoJson取得
   * @param rwCd 洪水予報区間コード
   */
  getRwFldfrGeoJson(rwCd) {
    // 10桁になるよう先頭ゼロ埋め
    const fileName = ("000000000" + rwCd).slice(-10);
    return Repository.get(`${resource}/rw/fldfr/` + fileName + `.json`);
  },
  /**
   * 水位周知GeoJson取得
   * @param rwCd 水位周知河川情報区間コード
   */
  getRwEvstgGeoJson(rwCd) {
    // 10桁になるよう先頭ゼロ埋め
    const fileName = ("000000000" + rwCd).slice(-10);
    return Repository.get(`${resource}/rw/evstg/` + fileName + `.json`);
  },
  /**
   * 水防警報GeoJson取得
   * @param rwCd 水防警報区間コード
   */
  getRwFldctlGeoJson(rwCd) {
    // 10桁になるよう先頭ゼロ埋め
    const fileName = ("000000000" + rwCd).slice(-10);
    return Repository.get(`${resource}/rw/fldctl/` + fileName + `.json`);
  },
};
